import * as t from "io-ts";

export const BBoxCodec = t.intersection([
  t.type({
    south: t.number,
    west: t.number,
    north: t.number,
    east: t.number,
  }),
  t.partial({}),
]);

export type BBox = t.TypeOf<typeof BBoxCodec>;
